const { $, YP } = window;

window.YP.StoreWorkshopsManager = () => {
    // Configuration
    const MAX_WORKSHOP_NAME_LENGTH = 25;

    // Selectors
    const SELECTORS = {
        mainContainer: '#productForms, #store_workshop_container',
        mainForm: '#productForms',
        mainSubmitButton: '.js-btn_confirm',
        workshopTag: '.workshop-tag',
        workshopRemove: '.js-workshop-remove',
        currentWorkshopsCartList: '.enable .cart-list-ticket-products',
        workshopListInput: '.js-workshop-data input',
        workshopDate: '.js-workshop-date',
        workshopDateContainer: '.js-workshop-date-container',
        workshopSessionContainer: '.js-workshop-session-container',
        cartTotal: '.js-cart-total',
    };

    const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');

    const ACTIVE_CHIP_CLASSES = 'u-bg__grey--90 u-color__white';

    // State variables
    let activeTagId = null;
    let cartIsExpanded = false;
    let actionCartIsValid = false;
    const REMOTE_CART = [];
    $(SELECTORS.currentWorkshopsCartList).find('li').each((i, domCartItem) => {
        const productType = window.JSON_PRODUCTS.find((product) => product.id === $(domCartItem).data('id'));
        if (!productType) return; // Product not found
        REMOTE_CART.push(productType);
    });
    let cart = [...REMOTE_CART];

    const maxQtyWorkshop = $('#store_workshop_list').data('maxqty');
    const minQtyWorkshop = $('#store_workshop_list').data('minqty');
    const freeWorkshopsCanBeCanceled = $('#store_workshop_list').data('free-workshops-can-be-canceled');

    return {
        init() {
            if (!$(SELECTORS.mainContainer).length) return;

            const self = this;

            // Reprend les activités du billet précédent : coche celles encore disponibles pour ce billet
            $('.js-reuse-activities-btn').on('click', function handleReuseActivities() {
                const $block = $(this).closest('.js-reuse-activities');
                const ids = $block.data('ids');
                let selected = 0;
                ids.forEach((id) => {
                    const $input = $(`.js-workshop-data[data-type="${id}"] input:not(:disabled)`);
                    if (!$input.length) return;
                    if (!$input.prop('checked')) $input.prop('checked', true).trigger('change');
                    selected += 1;
                });
                const format = (key, ...values) => values.reduce((text, value, i) => text.replace(`%${i + 1}%`, value), $block.data(key));
                const count = format(selected > 1 ? 'format-activities' : 'format-activity', selected);
                let message;
                if (selected === 0) {
                    message = format('format-none');
                } else if (selected < ids.length) {
                    message = format('format-partial', count, ids.length);
                } else {
                    message = format(selected === 1 ? 'format-all-one' : 'format-all', count);
                }
                $block.find('.js-reuse-activities-msg').text(message).removeAttr('hidden');
            });

            // Filtre par catégorie, une à la fois : recliquer la catégorie active revient à « Toutes »
            $(SELECTORS.mainForm).on('click', SELECTORS.workshopTag, function handleFilterTag(e) {
                e.preventDefault();
                const tagId = $(this).data('id');
                self.filterWorkshops(tagId === activeTagId ? null : tagId);
            });
            $(SELECTORS.mainForm).on('click', '.js-tag-all', (e) => {
                e.preventDefault();
                self.filterWorkshops(null);
            });
            // Les catégories prennent leurs couleurs au survol ou une fois sélectionnées
            $(SELECTORS.mainForm).on('mouseenter', SELECTORS.workshopTag, function handleTagHoverStart() {
                self.paintTag($(this), true);
            });
            $(SELECTORS.mainForm).on('mouseleave', SELECTORS.workshopTag, function handleTagHoverStop() {
                self.paintTag($(this), $(this).data('id') === activeTagId);
            });

            // Remove product from cart when clicking on the remove button
            $(SELECTORS.currentWorkshopsCartList).on('click', SELECTORS.workshopRemove, function handleRemoveFromCart(e) {
                e.preventDefault();
                const typeProductId = $(this).data('id');
                const typeProduct = window.JSON_PRODUCTS.find((product) => (
                    product.id === typeProductId
                ));
                self.removeProductFromCart(typeProduct);
                self.handleCartChange();
            });

            // Handle add/remove product event
            $(SELECTORS.mainForm).on('change', SELECTORS.workshopListInput, function handleProductChange() {
                const productTypeId = Number.parseInt($(this).parents('.js-workshop-data').data('type'), 10);
                const productType = window.JSON_PRODUCTS.find((product) => (
                    product.id === productTypeId
                ));
                if (!productType) return; // Product not found
                if (this.checked) {
                    self.addProductToCart(productType);
                } else {
                    self.removeProductFromCart(productType);
                }
                self.handleCartChange();
            });

            // Handle the collapse event of the workshop descriptions
            let lastMaxHeight = null;
            $(SELECTORS.mainForm).on('click', '.js-get-info', function handleDescriptionCollapse() {
                const parentDescription = $(this).siblings('.description');
                if (parentDescription.css('overflow-y') === 'hidden') {
                    parentDescription.css('overflow-y', 'visible');
                    lastMaxHeight = parentDescription.css('max-height');
                    parentDescription.css('max-height', '100%');
                    $(this).text('Fermer');
                } else {
                    parentDescription.css('overflow-y', 'hidden');
                    parentDescription.css('max-height', lastMaxHeight);
                    $(this).text('Plus de détails');
                }
            });

            this.initFixedCartBehavior();
            this.initAllWorkshopsFilter();

            // Prevent multiple form submit
            $(SELECTORS.mainForm).on('submit', () => {
                $(SELECTORS.mainSubmitButton).prop('disabled', true);
            });

            // /!\ Hack to handle invalid HTML form/input/submit usage /!\
            // The .js-btn_confirm button is not inside the form but only in the widget DOM
            // This event handler submit the related form
            $(SELECTORS.mainSubmitButton).on('click', function handleSubmitOutsideOfTheForm() {
                const isInForm = $(this).parents(SELECTORS.mainForm).length > 0;
                if (isInForm) return;
                $(SELECTORS.mainForm).submit();
            });
            if ($(SELECTORS.mainForm).length > 0) {
                // Formulaire ré-affiché en erreur (séance devenue complète) : les cases restées cochées font foi,
                // le panier en base ne contient plus les séances du billet courant
                $(SELECTORS.workshopListInput).filter(':checked').each(function addCheckedToCart() {
                    const productTypeId = Number.parseInt($(this).parents('.js-workshop-data').data('type'), 10);
                    const productType = window.JSON_PRODUCTS.find((product) => product.id === productTypeId);
                    if (productType) self.addProductToCart(productType);
                });
                this.handleCartChange();
                this.updateInputs();
            }

            // Ateliers repliables ; le panier ne l'est qu'en mobile
            const toggleWorkshop = ($block) => {
                $block.data('expanded', !$block.data('expanded'));
                self.setupAccordions();
            };
            // La zone cliquable couvre tout l'en-tête, padding du container compris
            $(SELECTORS.mainForm).on('click', '.u-workshops-block', function handleToggleWorkshop(e) {
                const $block = $(this);
                const inHeader = $(e.target).closest('.js-accordion-header').length > 0;
                const inPadding = e.target === this
                    && (!$block.data('expanded') || e.clientY <= $block.children('.js-accordion-header')[0].getBoundingClientRect().bottom);
                if (inHeader || inPadding) toggleWorkshop($block);
            });
            $(SELECTORS.mainForm).on('keydown', '.js-accordion-header', function handleToggleWorkshopKey(e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                toggleWorkshop($(this).closest('.u-workshops-block'));
            });
            $('.js-cart-toggle').on('click', () => {
                if (!MOBILE_QUERY.matches) return;
                cartIsExpanded = !cartIsExpanded;
                self.setupAccordions();
            });
            MOBILE_QUERY.addEventListener('change', () => self.setupAccordions());
            this.setupAccordions();
        },
        setupAccordions() {
            // L'en-tête est rendu par le widget PHP : seul l'état ouvert/fermé et le bouton suivent les séances cochées
            $('.u-workshops-block').each(function updateWorkshopAccordion() {
                const $block = $(this);
                const $header = $block.children('.js-accordion-header');
                const checked = $block.find('.js-workshop-data input:checked').length;
                const expanded = Boolean($block.data('expanded'));
                $header.attr('aria-expanded', expanded);
                // Ouvert : chevron pour replier. Fermé : nombre de séances choisies, ou « + » pour en ajouter
                const showCount = !expanded && checked > 0;
                $header.find('.js-accordion-action')
                    .toggleClass('c-btn--tertiary', expanded)
                    .toggleClass('c-btn--primary', showCount)
                    .toggleClass('c-btn--secondary', !expanded && !showCount);
                $header.find('.js-accordion-icon')
                    .toggle(!showCount)
                    .toggleClass('yp_font_chevron-up', expanded)
                    .toggleClass('yp_font_plus', !expanded);
                $header.find('.js-accordion-count').text(showCount ? checked : '').css('display', showCount ? 'flex' : 'none');
                $block.children('.js-accordion-body').toggle(expanded);
            });

            const isMobile = MOBILE_QUERY.matches;
            const cartExpanded = !isMobile || cartIsExpanded;
            $('.js-cart-toggle').css('cursor', isMobile ? 'pointer' : '')
                .find('.js-cart-chevron')
                .toggle(isMobile)
                .find('i')
                .toggleClass('yp_font_chevron-up', cartExpanded)
                .toggleClass('yp_font_chevron-down', !cartExpanded);
            $('.js-cart-toggle').closest('.c-container').find('.content').toggle(cartExpanded);
        },
        addProductToCart(productType) {
            const productAlreadyInCart = cart.some((product) => product.id === productType.id);
            if (productAlreadyInCart) {
                cart = cart.map((product) => {
                    if (product.id !== productType.id) return product;
                    return {
                        ...product,
                        toCancel: false,
                    };
                });
                return;
            }

            // Add product to JS Cart
            cart = cart.concat([{
                ...productType,
                toCancel: false,
            }]);
        },
        removeProductFromCart(productType) {
            const productInRemoteCart = REMOTE_CART.some((product) => (
                product.id === productType.id
            ));
            if (productInRemoteCart) { // Mark as remove
                cart = cart.map((product) => {
                    if (product.id !== productType.id) return product;
                    return {
                        ...product,
                        toCancel: true,
                    };
                });
            } else { // Remove product from JS Cart
                cart = cart.filter((product) => product.id !== productType.id);
            }

            $(`#select_type_product_workshop_products_${productType.id}`).prop('checked', false);
        },
        handleCartChange() {
            this.updateWorkshopsConflicts();
            this.updateDOMCart();
            this.updateCartTitle();
            this.updateTotalCart();
            this.updateActionCart();
            this.handleQuantityAvailable();
            this.setupAccordions();
        },
        updateDOMCart() {
            $(SELECTORS.currentWorkshopsCartList).empty();
            [...cart].sort((a, b) => a.begin - b.begin).forEach((productType) => {
                $(SELECTORS.currentWorkshopsCartList).append($(this.getTypeProductTemplate(productType)));
            });
        },
        updateCartTitle() {
            const $title = $('.js-cart-title');
            const tickets = $title.data('tickets');
            if (!(tickets > 1)) return;
            // Les activités des autres billets sont comptées par le serveur ; celles du billet courant suivent le panier JS
            const activities = Number($title.data('other-activities')) + cart.filter((product) => !product.toCancel).length;
            const parts = [String($title.data('format-tickets')).replace('%1%', tickets)];
            if (activities > 0) {
                parts.push(String($title.data(activities > 1 ? 'format-activities' : 'format-activity')).replace('%1%', activities));
            }
            $title.text(`${$title.data('label')} (${parts.join(', ')})`);
        },
        handleQuantityAvailable() {
            const countCurrentProduct = cart.filter((product) => !product.toCancel).length;
            if (Number.isInteger(minQtyWorkshop)) {
                if (countCurrentProduct < minQtyWorkshop) {
                    $(SELECTORS.mainSubmitButton).prop('disabled', true);
                } else {
                    $(SELECTORS.mainSubmitButton).prop('disabled', !actionCartIsValid);
                }
            }

            if (Number.isInteger(maxQtyWorkshop)) {
                if (countCurrentProduct >= maxQtyWorkshop) {
                    $(`${SELECTORS.mainForm} label:not(.u-workshop_disabled) input[type='checkbox']:not(:checked)`).prop('disabled', true);
                } else {
                    $(`${SELECTORS.mainForm} label:not(.u-workshop_disabled) input[type='checkbox']:not(:checked)`).prop('disabled', false);
                }
            }
        },
        getTypeProductTemplate(_productType) {
            const productType = _productType;
            const productInRemoteCart = REMOTE_CART.some((product) => (
                product.id === productType.id
            ));
            if (productType.name.length >= MAX_WORKSHOP_NAME_LENGTH) {
                productType.name = `${productType.name.substring(0, 25).split(' ').slice(0, -1).join(' ')}...`;
            }

            // Même rendu que le panier servi par PHP (yup_date_format 'EEE dd', date 'H:i') : « Ven. 05 · 14:00 », « Fri 05 · 14:00 »
            const culture = String($('#store_workshop_list').data('culture') || 'fr').replace('_', '-');
            const timeOptions = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
            const begin = new Date(productType.begin * 1000);
            const weekday = begin.toLocaleDateString(culture, { weekday: 'short' });
            const dayLabel = `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${String(begin.getDate()).padStart(2, '0')}`;
            const beginTime = begin.toLocaleTimeString(culture, timeOptions);
            const endTime = new Date(productType.end * 1000).toLocaleTimeString(culture, timeOptions);

            return `
            <li
                class="cart-list-product c-list c-list--stacked mb-2
                    ${productType.toCancel ? 'to-cancel' : ''}
                    ${(productType.hasConflict ?? false) ? 'warning' : ''}
                "
                data-id=${productType.id}
                data-booked=0
            >
                <div class="c-list__item" style="padding-right:8px">
                    ${productType.workshop_picture ? `
                        <span class="c-icon" style="flex:none;width:48px;height:48px;background-image:url('${productType.workshop_picture}');background-size:cover;background-position:center"></span>
                    ` : ''}
                        <div class="c-list__item-text u-width--flex px-2" style="min-width:0">
                            <div class="c-type-body--2">${productType.name}</div>
                            <div class="c-type-body--2 u-color__grey--60" style="white-space:nowrap">${dayLabel} · ${beginTime} - ${endTime}</div>
                        </div>
                    <div class="c-list__item-action" style="position:static;flex:none">
                        ${productType.locked !== true && !window.HIDE_PRICE ? `
                            <div class="c-type-body--2 u-color__grey--60 mr-2">
                                ${productType.amount === 0 ? 'Inclus' : `${productType.amount.toFixed(2)} €`}
                            </div>
                        ` : ''}
                        ${!productType.toCancel && (freeWorkshopsCanBeCanceled && productType.amount === 0) || !productInRemoteCart ? `
                            <a class="c-btn c-btn--small mr-0 c-btn--tertiary c-btn--square js-workshop-remove" href="#" data-id=${productType.id}>
                                <i class="yp_font yp_font_trash-2" style="position: absolute;" aria-hidden="true"></i>
                            </a>
                        ` : ''}
                        ${productType.toCancel ? `
                            <i class="yp_font yp_font_minus-circle u-color__red--40 u-font-size--5" aria-hidden="true"></i>
                        ` : ''}
                    </div>
                </div>
            </li>`;
        },
        initFixedCartBehavior() {
            if (!$('.fixedElement').length) return;

            const $fixedElement = $('.fixedElement');
            const $leftColumn = $('.event-page .u-col-8, .js-scroll-col-atelier');
            const $window = $(window);
            const $rightColumn = $fixedElement.parent();

            const spaceBottom = 62;
            const widthAdjustment = 16;
            let ticking = false;

            const updateFixedPosition = () => {
                // Lu à chaque scroll sur la colonne (toujours dans le flux) : au chargement, la question peut masquer le panier
                const rightColumnOffset = $rightColumn.offset().top;
                const rightColumnHeight = $fixedElement.outerHeight();
                const windowHeight = $window.height();
                const scrollTop = $window.scrollTop();
                const stickedOffset = (rightColumnOffset + rightColumnHeight)
                    - windowHeight + spaceBottom;

                const currentRightColumnLeft = $rightColumn.offset().left;
                const currentRightColumnWidth = $rightColumn.outerWidth();
                const columnPaddingLeft = parseInt($rightColumn.css('padding-left'), 10) || 0;

                const adjustedLeft = currentRightColumnLeft + columnPaddingLeft;
                const adjustedWidth = currentRightColumnWidth - widthAdjustment;

                $leftColumn.css('minHeight', rightColumnHeight);

                const shouldStick = rightColumnHeight > windowHeight - spaceBottom
                    - rightColumnOffset;
                const shouldStickBottom = shouldStick && scrollTop > stickedOffset;
                const shouldStickTop = !shouldStick && scrollTop > rightColumnOffset;

                $fixedElement.removeClass('sticked stickedtop');

                if (shouldStickBottom || shouldStickTop) {
                    $fixedElement.addClass(shouldStickBottom ? 'sticked' : 'stickedtop');
                    $fixedElement.css({
                        left: adjustedLeft,
                        width: adjustedWidth,
                    });
                } else {
                    $fixedElement.css({
                        left: 'auto',
                        width: 'auto',
                    });
                }

                ticking = false;
            };

            const handleScroll = () => {
                if (!ticking) {
                    requestAnimationFrame(updateFixedPosition);
                    ticking = true;
                }
            };

            $window.on('scroll', handleScroll);
            updateFixedPosition();
        },
        // Page « Liste des activités » : plusieurs catégories à la fois, la liste est rechargée par l'action
        // allShow (paramètre filterTag) ; le filtre du tunnel, lui, masque les activités dans la page
        initAllWorkshopsFilter() {
            const $container = $('#store_workshop_container');
            if (!$container.length) return;

            const grey = { 'background-color': 'transparent', color: '#9A9A9A', border: '1px solid #9A9A9A' };
            const colored = ($tag) => ({ 'background-color': $tag.data('background'), color: $tag.data('font'), border: '1px solid transparent' });
            let isLoading = false;

            $container.on('mouseenter', SELECTORS.workshopTag, function handleAllTagHoverStart() {
                $(this).css({ 'background-color': $(this).data('font'), color: $(this).data('background'), border: `1px solid ${$(this).data('background')}` });
            });
            $container.on('mouseleave', SELECTORS.workshopTag, function handleAllTagHoverStop() {
                $(this).css($(this).hasClass('active') ? colored($(this)) : grey);
            });
            $container.on('click', SELECTORS.workshopTag, function handleAllTagToggle(e) {
                e.preventDefault();
                if (isLoading) return;
                isLoading = true;
                const $tag = $(this).toggleClass('active');
                $tag.css($tag.hasClass('active') ? colored($tag) : grey);
                const filterTag = $container.find(`${SELECTORS.workshopTag}.active`).map(function extractTagId() {
                    return $(this).data('id');
                }).get();
                $('#store_workshop_list').css('opacity', 0.5);
                $.ajax({
                    type: 'GET',
                    url: window.location.href,
                    dataType: 'json',
                    data: { filterTag },
                    success(data) {
                        $('#store_workshop_list').html(data.view);
                    },
                    complete() {
                        isLoading = false;
                        $('#store_workshop_list').css('opacity', 1);
                    },
                });
            });
        },
        paintTag(tag, colored) {
            tag.css(colored ? {
                'background-color': tag.data('background'),
                color: tag.data('font'),
            } : {
                'background-color': '',
                color: '',
            });
        },
        filterWorkshops(tagId) {
            const self = this;
            activeTagId = tagId;
            $(SELECTORS.mainForm).find('.js-tag-all').toggleClass(ACTIVE_CHIP_CLASSES, tagId === null);
            $(SELECTORS.mainForm).find(SELECTORS.workshopTag).each(function paintChip() {
                self.paintTag($(this), $(this).data('id') === tagId);
            });
            // Masquées seulement : les séances cochées d'une activité filtrée restent dans le formulaire
            $('.u-workshops-block').each(function filterBlock() {
                const tagIds = String($(this).data('tag-ids') ?? '').split(',').filter(Boolean).map(Number);
                $(this).toggle(tagId === null || tagIds.includes(tagId));
            });
        },
        updateTotalCart() {
            const total = cart.reduce((currentTotal, product) => {
                if (product.toCancel !== true && product.locked !== true) {
                    return currentTotal + product.amount;
                }
                return currentTotal;
            }, window.CART_TOTAL);
            $(SELECTORS.cartTotal).html(total.toFixed(2));
        },
        updateActionCart() {
            const hasWorkshopsConflicts = this.hasWorkshopsConflicts();
            // Selected products or no product available
            const isValid = $(SELECTORS.currentWorkshopsCartList).find('li.cart-list-product:not(.disabled)').length > 0
            || $(SELECTORS.currentWorkshopsCartList).find('li.to-cancel').length > 0
            || $(SELECTORS.workshopListInput).not(':disabled').is(':checked')
            || (
                $('.list-products tbody tr').length
                && $('.list-products tbody tr:not(.u-workshop_disabled)').length <= 0
            );
            const isBlockedByConflict = hasWorkshopsConflicts && !window.CAN_BOOK_SAME_WORKSHOP_SLOT;
            actionCartIsValid = isValid && !isBlockedByConflict;
            // One button at a time: confirm a valid selection, otherwise skip the step.
            // A mandatory workshop keeps the confirm button, disabled by handleQuantityAvailable until the minimum is reached
            $(SELECTORS.mainSubmitButton)[actionCartIsValid || minQtyWorkshop > 0 ? 'show' : 'hide']();
            $('.js-btn_next')[!actionCartIsValid && minQtyWorkshop <= 0 ? 'show' : 'hide']();
            $('.warning-date')[hasWorkshopsConflicts ? 'show' : 'hide']();
        },
        hasWorkshopsConflicts() {
            return cart.some((product) => product.hasConflict ?? false);
        },
        updateWorkshopsConflicts() {
            cart = cart.map((product) => ({
                ...product,
                // Source: https://stackoverflow.com/a/325964
                hasConflict: product.toCancel === false && cart.some((nestedProduct) => (
                    nestedProduct.toCancel === false
                     && nestedProduct.id !== product.id
                     && (product.begin < nestedProduct.end)
                     && (product.end > nestedProduct.begin)
                )),
            }));
        },
        updateInputs() {
            const productIds = cart.map((product) => product.id);
            // Check the retrieved inputs accordingly to the local cart data
            $('#store_workshop_list').find(`input[value="${productIds.join('"],[value="')}"]`)
                .prop('checked', true);
        },
    };
};

// La question préalable répond dès que le HTML est prêt, sans attendre les images (window.load)
$(() => {
    $('.js-activities-gate-yes').on('click', (event) => {
        event.preventDefault();
        $('.js-activities-gate').remove();
        $('.js-activities-row').css('display', '');
    });
});

window.addEventListener('load', () => {
    YP.StoreWorkshopsManager().init();
});
